import React from 'react'
import CertificateLink from '../CertificateLink'
import { TEMPERATURE_REDUCTION_TREATMENT_ASTM_D4803 } from 'scenes/ProductDetails/components/ProductSpecs/contants'
import { LOGO_PERMACOOL } from 'utils/components/SpecLogo/constants/logos'
import SpecLogo from 'utils/components/SpecLogo'
import { useIntl } from 'react-intl'

const TemperatureReduction = ({ data }) => {
  const intl = useIntl();

  const isJsonString = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  return (
    <tr>
      <td>
        {intl.formatMessage({
          id: "ProductSpecAccordionBody.temperatureReductionTreatment",
        })}
      </td>
      {isJsonString(data.temperatureReductionTreatment) ? (
        <>
          <td className="d-flex align-items-center">
            <span>
              {JSON.parse(data.temperatureReductionTreatment).value ===
              TEMPERATURE_REDUCTION_TREATMENT_ASTM_D4803 ? (
                <SpecLogo spec={LOGO_PERMACOOL} />
              ) : (
                JSON.parse(data.temperatureReductionTreatment).value
              )}
            </span>
            <a
              className="technical_limitations ml-2"
              href={
                JSON.parse(data.temperatureReductionTreatment)
                  .technical_limitations
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-info-circle" />
            </a>
          </td>
        </>
      ) : (
        <>
          <td>{data.temperatureReductionTreatment}</td>
          <td>
            {data.temperatureReductionTreatmentCertificateFile && (
              <CertificateLink
                link={
                  data.certificateDomain +
                  data.temperatureReductionTreatmentCertificateFile
                }
              />
            )}
          </td>
        </>
      )}
    </tr>
  )
}

export default TemperatureReduction
